// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../../../styles/media'

const Component = styled.div`
  margin-bottom: 0.5rem;
  position: relative;
  cursor: pointer;
`

const Iframe = styled.iframe`
  pointer-events: none;
  display: block;
  margin: auto;
  width: 290px;
  max-width: 100%;
  height: 225px;
  ${media.xlUp} {
    width: 350px;
    height: 250px;
  }
`

const ClickOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

type Props = {
  src: string,
  onClick: Function
}

const Tour = ({ src, onClick }: Props) => (
  <Component>
    <Iframe src={src} frameBorder="0" allowFullScreen />
    <ClickOverlay onClick={() => onClick({ src })} />
  </Component>
)

export default Tour



// WEBPACK FOOTER //
// ./src/components/VirtualTours/components/Tour/index.js